var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlatCube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 280,
    width: 280,
    viewBox: "0 0 280 280",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#45984b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.648886,139.968493 L22.350093,72.466588 L139.853409,4.055566 L257.470366,72.012030 L140.648886,139.968493 Z "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#4aaa51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.535247,274.995060 L22.350093,207.265876 L22.350093,71.352948 L140.648886,139.423052 L140.535247,274.995060 Z "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#3c8642"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.648886,275.108700 L257.697645,207.265876 L257.356726,71.125669 L140.535247,139.195773 L140.648886,275.108700 Z "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlatCube);
export default __webpack_public_path__ + "static/media/flat-cube.cb953ebf6735b7eb5db4598dbdc943c0.svg";
export { ForwardRef as ReactComponent };